<script setup lang="ts">
    import { useSqlEditorStore } from '@/stores/sqlEditorStore.ts';

    const store = useSqlEditorStore();
</script>

<template>
    <b-notification
        v-show="store.errorMessage"
        :closable="false"
        type="is-danger">
        {{ store.errorMessage }}
    </b-notification>
</template>
